import React, {FunctionComponent} from 'react';
import cn from 'classnames';

import {StageState, UpdateState} from 'enums';
import { StateBar } from '../StateBar/StateBar';

interface IStageStateBarProps {
    className?: string
    state: StageState,
}

const stateMapping = {
    [StageState.Scheduled]: UpdateState.Scheduled,
    [StageState.Running]: UpdateState.Running,
    [StageState.Canceled]: UpdateState.Canceled,
    [StageState.Error]: UpdateState.Error,
    [StageState.Done]: UpdateState.Done,
}

export const StageStateBar: FunctionComponent<IStageStateBarProps> = function StageStateBar(props) {
    let { className, state } = props;

    className = cn(className, 'stageStateBar')

    return <StateBar
        state={stateMapping[state]}
        className={className}
    />
};